import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { SingleCardSelectCard } from './elements/SingleCardSelectCard'
import { SingleCardSelectOption } from './types/singleCardSelectOption'

interface SingleCardSelectProps {
  disabled?: boolean
  hasError?: boolean
  onChange: (id: number) => void
  options: SingleCardSelectOption[]
  value?: number
}

export const SingleCardSelect = ({
  disabled,
  hasError = false,
  onChange,
  options,
  value,
}: SingleCardSelectProps): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S8}>
    {options.map(({ id, label }) => (
      <SingleCardSelectCard
        disabled={disabled}
        hasError={hasError}
        id={id}
        isSelected={value === id}
        key={id}
        label={label}
        onClick={onChange}
      />
    ))}
  </Flex>
)
